import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Redirect = () => {
    const navigate = useNavigate();
    useEffect(()=>{
        navigate("/login")
    },[])

return(
  <Container>

  </Container>
)

}
export default Redirect;

const Container = styled.div`

`;